module.exports = __webpack_public_path__ + "static/projectGraphics-aebeeeb5e99768bed9b236eaa585883e.svg";